import { axiosPrivate_cookie } from "../services/api_cookie";
import { useEffect } from "react";
import useRefreshToken from "./useRefreshToken";
import useAuth from "./useAuth";

const useAxiosPrivateCookie = () => {
    const refresh = useRefreshToken();
    const { auth } = useAuth();

    useEffect(() => {

        const requestIntercept = axiosPrivate_cookie.interceptors.request.use(
            config => {
                if (!config.headers['Authorization']) {
                    //config.headers['Authorization'] = `Bearer ${auth?.user}`;
                }
                return config;
            }, (error) => Promise.reject(error)
        );

        const responseIntercept = axiosPrivate_cookie.interceptors.response.use(
            response => response,
            async (error) => {
                const prevRequest = error?.config;
                if (error?.response?.status === 403 && !prevRequest?.sent) {
                    prevRequest.sent = true;
                    const newAccessToken = await refresh();
                    //prevRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                    return axiosPrivate_cookie(prevRequest);
                }
                return Promise.reject(error);
            }
        );

        return () => {
            //axiosPrivate.interceptors.request.eject(requestIntercept);
            axiosPrivate_cookie.interceptors.response.eject(responseIntercept);
        }
    }, [auth, refresh])

    return axiosPrivate_cookie;
}

export default useAxiosPrivateCookie;